import React, { useState } from "react";
import "./Add_money.css";
import Form from "react-bootstrap/Form";
import Pink_Btn from "../../common/common_btn/pink_btn/Pink_Btn";
import Success_Modal from "../../common/common_modal/success_modal/Success_Modal";
import { formatAmount } from "../../../utils/common";
import { useForm } from "react-hook-form";
import { getAllWalletHistory, postAddMoney } from "../../../features/wallet/walletSlice";
import { useDispatch } from "react-redux";
import useRazorpay from "react-razorpay";

const Add_money = ({ Wallet }) => {
  const [showModal, setShowModal] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      amount: "",
    },
  });
  const amount = watch("amount");

  const quickAmounts = [500, 1000, 2000, 5000];
  const sendData = new FormData();



  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);


  const [Razorpay] = useRazorpay();

  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Om TApovan",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        // await setRazorId(res.razorpay_payment_id);
        await onSubmit(res.razorpay_payment_id);
      },
      prefill: {
        name: "Prajwal Vaychal",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const AddMoneyFuntion = async (data) => {

    console.log({ AddMoneyFuntion: data });
    sendData.append("amount", data?.amount);
    await handleRazorpay(data?.amount)
  }
  const onSubmit = async (transaction_id) => {

    setLoading(true);
    sendData.append("transaction_id", transaction_id);
    sendData.append("transaction_type", "credit");
    sendData.append("description", "OKKKK");

    try {


      const res = await dispatch(postAddMoney({ data: sendData, }));

      if (res?.meta?.requestStatus === "fulfilled") {
        setShowModal(true);
        reset();
        setTimeout(() => {
          setShowModal(false);
        }, 3000)
      }
      await dispatch(getAllWalletHistory());


    } catch (err) {

      console.error(err);

    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <section className="Add_money">
        <div className="row">
          <div className="col-lg-9 mx-auto">
            <div className="avabaldiv">
              <div className="bandiv">
                <p className="baltext">
                  &nbsp;<span>{formatAmount(Wallet?.amount) || "0"}</span>
                </p>
                <p className="baltext2">Available Balance</p>
              </div>
              <div className="icondiv">
                <img
                  className="coinseimg"
                  src={
                    process.env.PUBLIC_URL + "/assets/images/icons/coinse.png"
                  }
                />
              </div>
            </div>

            <div className="addmnbox">
              <h6 className="adh6">Add Money to Wallet</h6>
              <div className="form-group">
                <Form.Control
                  type="number"
                  placeholder="Enter Amount"
                  {...register("amount", {
                    required: "Amount is required",
                    min: {
                      value: 10,
                      message: "Minimum add amount is ₹10",
                    },
                    max: {
                      value: 50000,
                      message: "Maximum limit is ₹50,000",
                    },
                    validate: (value) =>
                      value > 0 || "Amount must be greater than 0",
                  })}
                />
                {errors.amount && (
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {errors.amount.message}
                  </p>
                )}


                <img
                  className="rupimg"
                  src={process.env.PUBLIC_URL + "/assets/images/icons/rupp.png"}
                />
              </div>

              <div className="row mt-4">
                {quickAmounts.map((amt) => (
                  <div className="col-6 mb-4" key={amt}>
                    <div
                      className={`amtdiv ${amount == amt ? "pop" : ""}`}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setValue("amount", amt, {
                          shouldValidate: true,
                        })
                      }
                    >
                      <p className="amt">
                        ₹ <span>{amt}</span>
                      </p>
                    </div>
                  </div>
                ))}

                {/* <div className="row mt-4">
                  <div className="col-6 mb-4">
                    <div className="amtdiv">
                      <p className="amt">
                        ₹&nbsp;<span>500</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-6 mb-4">
                    <div className="amtdiv pop">
                      <p className="amt">
                        ₹&nbsp;<span>1000</span>
                      </p>
                      <span className="poptxt">Popular</span>
                    </div>
                  </div>
                  <div className="col-6 mb-4">
                    <div className="amtdiv">
                      <p className="amt">
                        ₹&nbsp;<span>500</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-6 mb-4">
                    <div className="amtdiv">
                      <p className="amt">
                        ₹&nbsp;<span>500</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-12">
                    <Pink_Btn
                      btnText={"Add Balance"}
                      onClick={() => {
                        setShowModal(true);
                        setTimeout(() => {
                          setShowModal(false);
                        }, 3000);
                      }}
                    />
                  </div>
                </div> */}
              </div>
              <Pink_Btn
                btnText={loading ? "Processing..." : "Add Balance"}
                onClick={handleSubmit(AddMoneyFuntion)}
              />

            </div>
          </div>
        </div>

        <Success_Modal
          successText="Money Added to Wallet!"
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
        />
      </section>
    </>
  );
};

export default Add_money;
